import dayjs from "dayjs";
import { dayWidth, minutesInHour, monthWidth, singleDayWidth, zoom2ColumnWidth } from "./../constants";
import { DatesRange } from "./getDatesRange";

export const getTileXAndWidth = (item: DatesRange, range: DatesRange, zoom: number) => {
  let cellWidth: number;
 
  switch (zoom) {
    case 0:
    case 3:
      cellWidth = singleDayWidth;
      break;
    case 4:
      cellWidth = monthWidth;
      break;
    case 2:
      cellWidth = zoom2ColumnWidth;
      break;
    default:
      cellWidth = dayWidth;
  }
  const getX = () => {
    let position;
    switch (zoom) {
      case 2:
        position =
          (item.startDate.diff(range.startDate, "minute") / minutesInHour + 1) * cellWidth -
          cellWidth / 2;
        break;
      case 4:
        let monthPosition = 0;
        let dayDiff = item.startDate.diff(range.startDate, "day");
        const newDate = dayjs(range.startDate);

        for (let index = 1; index <= dayDiff; index++){
          const daysInMonth = newDate.dayOfYear(index).daysInMonth();
          monthPosition += cellWidth / daysInMonth;
        }
        position = monthPosition;
        break;
      default: {
        position = (item.startDate.diff(range.startDate, "day")) * cellWidth;
      }
    }
    return Math.max(0, position);
  };

  if ((item.startDate.isAfter(range.startDate) || item.startDate.isSame(range.startDate))
     && (item.endDate.isBefore(range.endDate) || item.endDate.isSame(range.endDate))) {
    let width = 0;
    switch (zoom) {
      case 2:
        width = (item.endDate.diff(item.startDate, "minute") / minutesInHour) * cellWidth;
        break;
      case 4:
        const dayDiff = item.endDate.diff(item.startDate, "day"); 
        let dayOfYear = item.startDate.dayOfYear();
        for (let index = 1; index <= dayDiff; index++){
          const daysInMonth = dayjs(item.startDate).dayOfYear(dayOfYear).daysInMonth();
          width += cellWidth / daysInMonth;
          if(index == 1)
            width += cellWidth / daysInMonth;
          dayOfYear++;
        }
        break;
      default:
        width = item.endDate.diff(item.startDate, "day") * cellWidth + cellWidth;
    }

    return { x: getX(), width };
  }

  if ((item.startDate.isBefore(range.startDate) || item.startDate.isSame(range.startDate)) 
    && (item.endDate.isBefore(range.endDate) || item.endDate.isSame(range.endDate))) {
    let width;
    switch (zoom) {
      case 2:
        width =
          (item.endDate.diff(range.startDate, "minute") / minutesInHour) * cellWidth +
          0.5 * cellWidth;
        break;
      case 4:
        width = item.endDate.diff(range.startDate, "month") * cellWidth + cellWidth;
        break;
      default:
        width = item.endDate.diff(range.startDate, "day") * cellWidth + cellWidth;
    }

    return { x: getX(), width };
  }

  if ((item.startDate.isAfter(range.startDate) || item.startDate.isSame(range.startDate))
    && (item.endDate.isAfter(range.endDate) || item.endDate.isSame(range.endDate))) {
    let width;
    switch (zoom) {
      case 2:
        width = (range.endDate.diff(item.startDate, "minute") / minutesInHour) * cellWidth;
        break;
      case 4:
        width = range.endDate.diff(item.startDate, "month") * cellWidth + cellWidth;
        break;
      default:
        width = range.endDate.diff(item.startDate, "day") * cellWidth + cellWidth;
    }

    return { x: getX(), width };
  }

  if ((item.startDate.isBefore(range.startDate) || item.startDate.isSame(range.startDate)) 
    && (item.endDate.isAfter(range.endDate) || item.endDate.isSame(range.endDate))) {
    let width;
    switch (zoom) {
      case 2:
        width = (range.endDate.diff(range.startDate, "minute") / minutesInHour) * cellWidth;
        break;
      case 4:
        width = item.endDate.diff(range.startDate, "month") * cellWidth + cellWidth;
        break;
      default:
        width = range.endDate.diff(range.startDate, "day") * cellWidth + cellWidth;
    }

    return { x: getX(), width };
  }
  return { x: getX(), width: 0 };
};
